<template>
<div class="chapter">
<div class="inner_page">
<h1 class="western6" id="calibre_toc_3">Chapter 2</h1>
<p class="western7">I just wanted to stand there, drinking in the
afternoon sun. This section of Route 29 in Arlington is quiet that
time of day. At least, it has been since a good-sized chunk of the
population started croaking, coming back to life, eating their
neighbors, and somehow forgetting to show up for their fulfilling
IT and government contracting jobs every day.</p>
<p class="western7">They declared martial law during the start of
the Emergency, but much of the enforcement slacked off around
non-critical areas. The suburbs, for the most part, were classified
as non-critical. Even so, in this neck of the woods, you’re more
likely to see a stream of urban camo-painted vehicles, driven by
various members of the Armed Forces, rather than morning commuters.
When I was younger, we’d hang out on the way to school and beat the
steaming poo out of one another while counting Volkswagens. These
days, you shouldn’t play games like “Punch Buggy” with military
Humvees, because there are more of them moving around than commuter
cars. That game nowadays always devolves into a fistfight and a kid
gets his nose broken. And I dislike screaming children.</p>
<p class="western7">However, once in a while, the kid is
screaming because Mom and Dad are about to force them into a corner
and bite their ears off. Like today. I heard the noises before I
decided to stroll up to the burnt-out McDonalds to confirm what I
suspected.</p>
<p class="western7">Yeah.</p>
<p class="western7">Dad, I guess, had backed his son into a box
of mostly melted Happy Meal toys and was doing his level best to
eat the kid alive. Shit.</p>
<p class="western7">“Pops! Back off the youngster!”</p>
<p class="western7">The man, covered with gore, looked up and out
across the wilted plastic seats in the remains of the dining room
and smiled at me.</p>
<p class="western7">“Don’t you see, this is just a little family
squabble—nothing to worry about. Fuck off, Chester.”</p>
<p class="western7">I had a hard time believing that, watching
the little boy writhing underneath his hands.</p>
<p class="western7">“My name isn’t Chester, and I’m not going to
let you munch on that kid.”</p>
<p class="western7">Dad wasn’t one to waste time. He stood up and
hurled himself through the distance that separated us. I’ll admit
that, in retrospect, he had one of the best Angry Zombie Growls
I’ve heard. What he didn’t have was any clue about human body
mechanics.</p>
<p class="western7">Faster. Meaner. Claws. But just as
stupid.</p>
<p class="western7">Charging someone with your arms spread wide,
foaming at the mouth, and at full speed is not smart and won’t
prepare you for someone who charges back at you.</p>
<p class="western7">I ran straight at him, popped the Man Scythe
out of the Kydex rig across my back, and snapped the blade out as I
moved. To his credit, Dad did not flinch, stop, or do anything else
that would have made my day more unfortunate. He just kept coming
like a pasty-white, scrawny, undead linebacker.</p>
<p class="western7">I planted my leading foot, which checked my
forward motion, and collapsed to one knee while pivoting. His arm
went right over my head. I came back to my feet, following his
motion so that we faced the same direction. He was still in
range.</p>
<p class="western7">Swing, batter!</p>
<p class="western7">The Man Scythe is a compact, folding, melee
weapon that is based on a single-handed scythe design. If you’re a
martial arts fan, you’ve seen a kama before—it’s a folding kama on
steroids.</p>
<p class="western7">The frame is milled titanium, with a
synthetic rubber grip for traction and shock absorption. The blade
is three-quarters the length of the entire weapon, and it folds out
into position with a flick of the wrist. A slot in the titanium
forms a tongue that snaps into place under the blade, keeping it
open for use and does a good bit to keep the blade from folding
back in when you least want it.</p>
<p class="western7">I had this one made for me. No bullshit
off-the-shelf models, as if anyone could mass-produce a thing of
beauty like this. The blade is hand-forged, laminated steel,
selectively hardened, with a hamaguri (clam) edge profile, as sharp
and strong as a samurai sword. Don’t ask me what it cost to have it
made—I may never be able to erase that debt.</p>
<p class="western7">Dad’s head popped off his shoulders, and the
body kept going, spraying blood in a beautiful arc as it fell
forward. I didn’t even feel it when the scythe sheared his
vertebrae. The blade is a testament to modern workmanship, executed
by a Master of his craft.</p>
<p class="western7">The kid screamed—he was conscious enough to
watch the show. Shit, again.</p>
<p class="western7">I figured that I’d cope with him as soon as
I’d finished the necessary process. You have to open the skull to
the air. You can either squish the brains around with your boot or
hope for hungry animals of one kind or another to find it and
consume it. In the light of day, with people milling about, animals
are less likely, which means the first method is the one to
use.</p>
<p class="western7">Boot.</p>
<p class="western7">The back of the scythe blade ends in a
beveled spike. It was a thoughtful design decision on the part of
the whackjob who came up with the idea. (That would be me. My
self-deprecating sense of humor will be the death of me.) All you
have to do is reverse your grip, spike forward, and give the
decapitated head two or three love taps. By the time you’re
finished, either the brain will be exposed, or you will have
sufficiently damaged the brain and won’t have to stick your boot
in.</p>
<p class="western7">The scythe came down with a positive sounding
thunk, albeit a bit deeper than I had planned. I was about to put
my foot on the cranium to pull the blade free when I heard the kid
screaming “My daddy!” over and over again, right behind me.</p>
<p class="western7">I spun around, gave the child a complete dose
of the “Hairy Eyeball,” and was very disappointed when he didn’t
stop the noise.</p>
<p class="western7">“Kid! Shut the fuck up!” I bellowed at him,
gesturing with both hands. “Your daddy was eating you!”</p>
<p class="western7">The little boy’s eyes bugged straight out of
his head, the remaining color drained from his face, and he passed
out. I marveled at my success and was about ready to pat myself on
the back for properly establishing my dominance and pointing out
the reality of the situation, when I realized something.</p>
<p class="western7">I had never put the scythe down. I’d been
flailing around in front of the kid with it still in my hand,
flinging his father’s head around in front of him like some kind of
macabre magic wand. His short little life would be forever tainted
by the image of a madman yelling while his own dad’s bloody noggin
danced in front of his face.</p>
<p class="western7">There have been times when I knew what I’d
just done was a one-way ticket to Hell. In that instance, I was
sure I’d just earned a table in the chef’s kitchen in the club car
to Hell.</p>
<p class="western7">“Aw.” I was very earnest. “I’m really sorry,
kid. I didn’t mean to do that to you.”</p>
<p class="western7">But he was out. Passed clean out—little
psyche gone completely AWOL. That really did not help the situation
because I really wanted to confess myself to this little fellow and
have him forgive me for terrorizing him. That was no way to
die.</p>
<p class="western7">I took a good look at his visible wounds and
sighed. He wouldn’t make it. Emergency medicine didn’t exist for
people who carry the virus. Ninety percent of the time, if a
carrier is wounded, they wouldn’t live long enough for an ambulance
to arrive. The blood draws zombies from all around.</p>
<p class="western7">“Fuck me!” I stormed away from the little
prone form on the concrete and proceeded to dash the head against
the curb. Destroy the brain and get the damnable thing off the
spike of my tool. That was about all the satisfaction I would be
getting out of this.</p>
<p class="western7">Some moist minutes later, I cleaned off the
blade with my shirttail and was just about ready to fold it down,
stow it, and move on. Then I heard the little boy stir and start
crying. It went way beyond pitiful and I knew that I wouldn’t be
able to leave him there to fend for himself. Tears get me every
time and I know it.</p>
<p class="western7">It was Hard Lesson Time, and there was
nothing I could do about it. I got down on my knees beside him and
tried to keep a wary eye on our surroundings.</p>
<p class="western7">“Uh. Hey. Your dad was eating you because
you’re infected with the virus that makes zombies. You’re hurt
really bad.” I realized that saying all of this was pointless, but
I couldn’t just let him die alone without someone. I kept talking
to him.</p>
<p class="western7">“Kid. Do you have any family or anyone?”</p>
<p class="western7">He just shook his head at me.</p>
<p class="western7">“Nobody? No family? No nothing?”</p>
<p class="western7">Same shake of the head, tears flying left and
right.</p>
<p class="western7">There was a chance that I could flag down a
Humvee in a little bit and hand him off to the military if he lived
long enough. It was an option. They’d take him to the local
processing station and put him in the next convoy of infected
people that they send to the Pens in Tennessee. They might even
patch him up some.</p>
<p class="western7">The Pens had been set up to handle situations
like these. An infected child who is orphaned with no family or
means of support, the elderly, and anyone who cannot reasonably be
expected to contribute to what remains of America’s economic
infrastructure were sent to the Pens. It was not a great solution,
but it was better than nothing.</p>
<p class="western7">He’d live for a while in one of the heavily
guarded tent cities that had been slapped together out there.
Maybe, but not if the convoy was overrun or the Pens invaded. Then
he would go back to being chow, only to join the ranks a little
while later.</p>
<p class="western7">My choices were not fabulous. Toss the kid at
a Humvee, leading to his likely death. Or leave the kid to fend for
himself—infected and about to die.</p>
<p class="western7">The choices looked like: die; die; live for a
little bit, terrified, hungry, no medical care, and <i class="calibre4">probably</i>
die.</p>
<p class="western7">I should have just let his father do the
dirty work, but for the fact that it would mean the boy would’ve
died the most horrible way imaginable. Maybe I didn’t do anything
good for the kid after all.</p>
<p class="western7">We just held our places, staring at each
other. Weepy Kid and Zombie-cide Man.</p>
<p class="western7">“Kid, how old are you?”</p>
<p class="western7">“I’m seven years old,” he whispered, starting
to wheeze a little bit. Not good.</p>
<p class="western7">“Okay.” At that age, he really wouldn’t get
the complexity of the choice that I wanted to lay down in front of
him. There was no doubt in my mind that choosing whether to die now
or die later would be too much for any child to really grasp. But I
had to give it a try, because I couldn’t choose.</p>
<p class="western7">“Kid. I need you to think about something. I
know you’re really upset now, but you have to think about what I’m
going to ask you. Can you do that?”</p>
<p class="western7">“Huh?”</p>
<p class="western7">Great. Just great.</p>
<p class="western7">“Do you want bad things to happen to you
today, or do you want bad things to happen to you tomorrow or the
next day?”</p>
<p class="western7">He looked at me with the glazed eyes of the
utterly bereft. Tears had dried on his cheeks, and snot had
trickled down his face. If it hadn’t been for the expensively
tasteful clothes, he could have been any tragic victim from any
Third World country you could name. He was the sort of child that
gets plastered all over “Adopt Timmy from War-Torn Belize”
advertisements.</p>
<p class="western7">“Bad things have already happened today,” he
whispered. “I don’t want tomorrow to be bad, too.”</p>
<p class="western7">I nodded at him. This reduced the options I
was considering by one. Don’t hand him to the military. Fuck. I was
wasting time.</p>
<p class="western7">“Do you want bad things that happen fast and
are over, or do you want bad things that might take a while before
they stop?”</p>
<p class="western7">“Fast bad things.” He didn’t even pause
before he answered. Bam. Clarity.</p>
<p class="western7">I couldn’t leave him to fend for himself, be
hunted, and then eaten. I also couldn’t take him with me, because
he’d just be a juicy worm on the fishing pole. They’d find him and
me. Worse, the kid could infect me somehow.</p>
<p class="western7">I nodded at him again, and took a deep
breath.</p>
<p class="western7">The boy said, “You killed my dad. Are you
going to kill me, too?”</p>
<p class="western7">The breath rattled out of me, and I had
trouble taking in another one. I don’t know how this little boy
knew, but he’d figured it out. Sure, I could just do it and never
answer his question, but I knew that it would eat at me, strain my
resolve, and give me more reason to hate myself for the things I
had to do to survive.</p>
<p class="western7">“Yes.” I said it.</p>
<p class="western7">“Why?”</p>
<p class="western7">“Because if I don’t, things worse than your
father will find you really soon. They’ll eat you, just like he
wanted to, and then you’ll become just like them. You will go out
and eat people.” The words tumbled out of me in one breath.</p>
<p class="western7">“Oh,” he replied in that small voice children
use when something makes sense. “I don’t want to eat people. It’s
bad and it hurts them.”</p>
<p class="western7">His eyes started to glass over.</p>
<p class="western7">“You’re right,” I said, looking into his
fading eyes. They were a really warm brown. “Eating people does
hurt them. I’m proud of you that you don’t want to hurt people like
that.”</p>
<p class="western7">I still don’t believe it, but he actually
smiled. It was a good smile. I bet there were little kids like him
who went to the guillotine, being brave like that.</p>
<p class="western7">“Hey,” I said, “do you see that cloud over
there? The one that looks like a duck?”</p>
<p class="western7">He turned away from me and looked up. It was
the last conscious thing he ever did. Between the beats of my
heart, this innocent little boy went rigid, relaxed, rattled deep
in his tiny chest, and gave up the ghost. I’d waited too long.</p>
<p class="western7">Damn it. Damn it. Damn it.</p>
<p class="western7">I’m sorry. I’d hoped to do better for you
than talk you to death, kid.</p>
<p class="western7">It is always the same story, a decent sort of
person who didn’t deserve to have their life tragically cut short.
There was only one thing left to do: destroy the brain and then
move on.</p>
<p class="western7">When it was done, I cleaned off the scythe,
folded the blade back into the handle, and snapped it back into the
rig. I wasn’t seeing very clearly or breathing very easily. My face
was wet.</p>
<p class="western7">All I could do was walk away from it. By the
time I made it back to my place, my face was dry again.</p>
<h1 class="western8">
</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_f099aff482e799492a35054ee1867e1f_WrMliK.ch.fixed.fc.tidied.stylehacked.xfixed_split_005.vue?014f6223